import React from 'react'

import * as BloqueosPeriodosService from 'services/bloqueosPeriodo.service'

const PeriodoContext = React.createContext({
  actualizarEstados: null
})

const { Provider } = PeriodoContext

const PeriodoProvider = props => {

  const actualizarEstados = React.useCallback(() => {
    BloqueosPeriodosService.obtenerBloqueos()
      .then(({ data }) => {
        for (let i = 0; i < data.mayorizados.length; i++) {
          const element = data.mayorizados[i]
          const stringElement = `${i}`.padStart(2, '0')
          const nodosActualizar = document.getElementsByClassName(`boton-periodo-mes-${stringElement}`)
          if (element === 1) {
            for (let j = 0; j < nodosActualizar.length; j++) {
              const nodoParche = nodosActualizar[j]
              nodoParche.classList.add('bg-warning')
            }
          } else {
            for (let j = 0; j < nodosActualizar.length; j++) {
              const nodoParche = nodosActualizar[j]
              nodoParche.classList.remove('bg-warning')
            }
          }
        }
      })
      .catch(() => {
        // __zariContext.snack('error', 'No se pudo obtener información de los periodos')
      })
  }, [])

  return <Provider value={{ actualizarEstados }}>{props.children}</Provider>
}

export { PeriodoProvider, PeriodoContext }
